// Function to fetch the cart
let isUpdatingCart = false;

async function fetchCart() {
  const response = await fetch("/cart.js", {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  return response.json();
}

// Function to add a product to the cart
async function addProductToCart(productId, quantity = 1) {
  jQuery
    .post(window.Shopify.routes.root + "cart/add.js", {
      items: [
        {
          id: productId,
          quantity: 1,
        },
      ],
      sections: "cart-drawer,cart-bubble",
    })
    .then((state) => {
      const parsedState = JSON.parse(state);
      renderContents(parsedState);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

// Function to add a product to the cart
async function removeProductToCart(productId, quantity = 0) {
  jQuery
    .post(window.Shopify.routes.root + "cart/change.js", {
      id: productId, // The ID of the product variant in the cart
      quantity: quantity, // Quantity to update; set to 0 to remove the item
      sections: "cart-drawer,cart-bubble,main-cart", // Optional: for updating specific sections
    })
    .then((state) => {
      const parsedState = JSON.parse(state);
      renderContents(parsedState);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

async function removeMultipleProducts(updates) {
  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      updates,
      sections: ["cart-drawer", "cart-bubble", "main-cart"], // Specify the sections you want to update
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("Updated cart:", data);
      renderContents(data);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

function getSectionInnerHTML(html, selector = ".shopify-section") {
  return new DOMParser()
    .parseFromString(html, "text/html")
    .querySelector(selector).innerHTML;
}
function getSectionsToRender() {
  return [
    {
      id: "Cart",
      section: "main-cart",
      selector: ".thb-cart-form",
    },
    {
      id: "Cart-Drawer",
      section: "cart-drawer",
      selector: ".cart-drawer",
    },
    {
      id: "cart-drawer-toggle",
      section: "cart-bubble",
      selector: ".thb-item-count",
    },
  ];
}

function renderContents(parsedState) {
  getSectionsToRender().forEach((section) => {
    if (!document.getElementById(section.id)) {
      return;
    }
    const elementToReplace =
      document.getElementById(section.id).querySelector(section.selector) ||
      document.getElementById(section.id);
    elementToReplace.innerHTML = getSectionInnerHTML(
      parsedState.sections[section.section],
      section.selector
    );

    if (typeof CartDrawer !== "undefined") {
      new CartDrawer();
    }
    if (typeof Cart !== "undefined") {
      new Cart().renderContents(parsedState);
    }
  });
  if (window.location.href.indexOf("/cart") === -1) {
    let product_drawer = document.getElementById("Product-Drawer");
    if (document.getElementById("Cart-Drawer")) {
      document.body.classList.add("open-cc");
      document.body.classList.add("open-cart");
      document.getElementById("Cart-Drawer").classList.add("active");
      dispatchCustomEvent("cart-drawer:open");
    }
  }
}

// Polling function to listen for cart updates
let previousCartState = null;

async function checkCartUpdates() {
  const cart = await fetchCart();

  // Compare with the previous state to detect updates

  previousCartState = cart;
  var expeditedProductInCart = 0;

  let totalEligibleCartValue = 0;
  let nonPingTaylormadeValue = 0;
  let giftCardAlreadyInCart = false;
  let rangefinderAlreadyInCart = false;
  let excludedVendors = "";

  if (freeGiftPromoOn) {
    excludedVendors = document.getElementById("freeGiftExcludedVendors").getAttribute("data-vendors");
    var freeGift1 = document.getElementById("freeGift1").getAttribute("data-id");
    var freeGift1Threshold = document.getElementById("freeGift1").getAttribute("data-threshold");
    var freeGift2 = document.getElementById("freeGift2").getAttribute("data-id");
    var freeGift2Threshold = document.getElementById("freeGift2").getAttribute("data-threshold");
  }
  var clubCount = 0;
  // Calculate total value and filtered value
  cart.items.forEach((item) => {
    if (freeGiftPromoOn) {
      if (item.variant_id == freeGift1) {
        rangefinderAlreadyInCart = true;
      }
      if (item.variant_id == freeGift2) {
        giftCardAlreadyInCart = true;
      }

      if ( !excludedVendors.includes(item.vendor) && item.id != freeGift1 &&  item.id != freeGift2 ) {
        nonPingTaylormadeValue +=
          (item.quantity * (item.price / Shopify.currency.rate)) / 100;
      }
    }

    var itemProductType = item.product_type;

    if (itemProductType.includes("Expedited")) {
      expeditedProductInCart = item.id;
    }
  });

  if (document.getElementById("expeditedToggle")) {
    const expeditedToggle = document.getElementById("expeditedToggle");
    var expeditedProductInToggle = expeditedToggle.getAttribute("data-expedite-id"); // "Golf Club"
  } else {
    var expeditedProductInToggle = 0;
  }

  const productsToRemove = [];
  if (expeditedProductInCart && expeditedProductInCart != expeditedProductInToggle) {
    //remove current expedite in cart and add new

    //await removeProductToCart(expeditedProductInCart);
    productsToRemove.push(expeditedProductInCart);

    if (expeditedProductInCart != 0) {
      var expeditedProductToAdd = true;
      //await addProductToCart(expeditedProductInToggle);
    }
  }

  if (freeGiftPromoOn) {
    //adding both to cart if both are not present
    if (
      rangefinderAlreadyInCart === false && giftCardAlreadyInCart === false && nonPingTaylormadeValue > freeGift2Threshold
    ) {
      if (freeGift2 != "") {
        addProductToCart(Number(freeGift2));
      }

      if (freeGift2 === "" && nonPingTaylormadeValue > freeGift1Threshold) {
        addProductToCart(Number(freeGift1));
        return;
      } else {
        if (nonPingTaylormadeValue > freeGift1Threshold) {
          setTimeout(function () {
            addProductToCart(Number(freeGift1));
          }, 1500);
          return;
        }
      }
    }

    if (
      rangefinderAlreadyInCart === false &&
      nonPingTaylormadeValue > freeGift1Threshold
    ) {
      //add rangefinder
      addProductToCart(Number(freeGift1));
    }

    if (
      giftCardAlreadyInCart === false &&
      nonPingTaylormadeValue > freeGift2Threshold &&
      freeGift2 != ""
    ) {
      //add gift card
      addProductToCart(Number(freeGift2));
    }

    if (nonPingTaylormadeValue < freeGift1Threshold) {
      if (rangefinderAlreadyInCart) productsToRemove.push(Number(freeGift1));
    }
    if (nonPingTaylormadeValue < freeGift2Threshold) {
      if (giftCardAlreadyInCart) productsToRemove.push(Number(freeGift2));
    }
  }

  if (productsToRemove.length > 0) {
    console.log("ids", productsToRemove);
    if (productsToRemove.length < 2) {
      for (const productId of productsToRemove) {
        await removeProductToCart(productId);
        console.log(productId);
      }
    } else {
      let updates = productsToRemove.reduce((acc, id) => {
        acc[id] = 0; // Set the quantity to 0 to remove the product
        return acc;
      }, {});
      await removeMultipleProducts(updates);
    }
  }

  if (expeditedProductToAdd) {
    setTimeout(function () {
      addProductToCart(expeditedProductInToggle);
    }, 1600);
  }
}

document.addEventListener("line-item:change:end", async function (evt) {
  ///if free gift 1 is being removed, don't run checkUpdates so that gift doesn't get added back
  if (
    evt.detail.cart.items_removed &&
    evt.detail.cart.items_removed.length > 0 &&
    evt.detail.cart.items_removed[0].variant_id &&
    Number(document.getElementById("freeGift1").getAttribute("data-id")) ===
      evt.detail.cart.items_removed[0].variant_id
  ) {
    return;
  }

  if (isUpdatingCart) {
    //cart is updating, don't execute twice
    return;
  }
  isUpdatingCart = true; // Set the flag before starting cart updates

  try {
    // Perform cart updates
    await checkCartUpdates();
  } finally {
    isUpdatingCart = false; // Reset the flag after updates complete
  }
});

// Add an event listener to handle the click event
function expeditedToggle(expeditedProduct) {
  const expeditedCheckbox = document.getElementById("expeditedToggle");
  if (expeditedCheckbox.checked === true) {
    addProductToCart(expeditedProduct);
  } else {
    removeProductToCart(expeditedProduct);
  }
}

document.addEventListener("cart:item-added", function (evt) {
  const expeditedCheckbox = document.getElementById("expeditedToggle");
  if (expeditedCheckbox && expeditedCheckbox.checked === true) {
  } else {
    const linkElement = document.querySelector("a[title='Expedited Build']");
    if (linkElement) {
      // Extract the href value
      const hrefValue = linkElement.getAttribute("href");

      // Use URLSearchParams to parse the query string
      const urlParams = new URLSearchParams(hrefValue.split("?")[1]);
      const variantId = urlParams.get("variant");

      removeProductToCart(variantId);
      setTimeout(function () {
        document
          .querySelector(".cart-drawer-buttons")
          ?.insertAdjacentHTML(
            "beforebegin",
            '<p style="font-size:11px;margin-top:8px;color:red;">Expedited build is not available for this product and has been removed from your order.</p>'
          );
      }, 1600);
    }
  }

  checkCartUpdates();
});
